import type { IconBaseProps } from "./Icon";

export default function PlayIcon({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 10 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Play</title>
      <path
        d="M9.88649 6.59654L1.13775 12.0692L0.207031 12.6462V0.546875L9.88649 6.59654ZM8.11813 6.59654L1.13775 2.22217V10.9709L8.11813 6.59654Z"
        fill="currentColor"
      />
    </svg>
  );
}
